import { render, staticRenderFns } from "./InitialAvatar.vue?vue&type=template&id=54e648e5&scoped=true&"
import script from "./InitialAvatar.vue?vue&type=script&lang=js&"
export * from "./InitialAvatar.vue?vue&type=script&lang=js&"
import style0 from "./InitialAvatar.vue?vue&type=style&index=0&id=54e648e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e648e5",
  null
  
)

export default component.exports